import React from 'react'
import NewPaymentModal from './NewPaymentModal'
import { StateProvider } from '@State'
import AddPaymentButton from './AddPaymentButton'
import RoyaltiesToPayModal from './RoyaltiesToPayModal'
import CommissionsToPayModal from './CommissionsToPayModal'
import reducer from '../reducer'
import { Toaster } from '@CommonComponents/toast'

const App = () => {
  const initialState = {
    newPaymentModalOpen: false,
    royaltyModalOpen: false,
    commissionModalOpen: false,
    newPaymentDescription: '',
    newPaymentAmount: '',
    newPaymentTransactionID: '',
    newPaymentCoursenum: '',
    royaltiesOwed: [],
    newSource: '',
    newInvoiceNumber: '',
    commissions: [],
    paymentItemId: '',
    salespeople: [],
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <Toaster />
      <AddPaymentButton />
      <NewPaymentModal />
      <RoyaltiesToPayModal />
      <CommissionsToPayModal />
    </StateProvider>
  )
}

export default App
